import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { ToolbarButton } from "./../../_shared/toolbar-button/toolbar-button.js";
const DisplayLinkPreview = ({ toolbarItem }) => {
  const { t } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement(
    ToolbarButton,
    {
      active: toolbarItem.attributes.active,
      tooltip: t(toolbarItem.presentation?.tooltip),
      onClick: () => {
        toolbarItem.commands.click();
      },
      prefix: toolbarItem.presentation?.icon,
      dataHook: toolbarItem.presentation?.dataHook,
      tabIndex: toolbarItem.presentation.tabIndex
    }
  );
};
export {
  DisplayLinkPreview
};
//# sourceMappingURL=display-link-preview-button.js.map
